import { useModal } from '@billy/design-system'
import { useCallback } from 'react'

import type { UiSourceValue } from '@features/reconciliation/enums'

import { ModalId } from '../../../enums/modalId'
import { connectBankModalUiSourceStore } from '../utils/connectBankModalUiSourceStore'

export const useOpenConnectBankModal = () => {
  const { open } = useModal(ModalId.BankConnectionAddAccountModal)

  return useCallback(
    (uiSource: UiSourceValue) => {
      connectBankModalUiSourceStore.set(uiSource)
      open()
    },
    [open],
  )
}
